import { EdgeLabelRenderer, EdgeProps, getBezierPath } from '@xyflow/react';

import React from 'react';

import { PlayArrow } from '@mui/icons-material';
import { Button, alpha, useTheme } from '@mui/material';

// Interface for promote edge data
export interface PromoteEdgeData {
	onPromote: (sourceEnvironmentId: string, targetEnvironmentId: string) => void;
	sourceEnvironmentId: string;
	targetEnvironmentId: string;
}

type PromoteEdgeProps = EdgeProps & { data: PromoteEdgeData };

export default function PromoteEdge({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, style, markerEnd, data }: PromoteEdgeProps) {
	const theme = useTheme();
	const [edgePath, labelX, labelY] = getBezierPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
	});

	const handlePromoteClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (data?.onPromote && data.sourceEnvironmentId && data.targetEnvironmentId) {
			data.onPromote(data.sourceEnvironmentId, data.targetEnvironmentId);
		}
	};

	return (
		<>
			<path id={id} style={style} className="react-flow__edge-path" d={edgePath} markerEnd={markerEnd} />
			<EdgeLabelRenderer>
				<div
					className="nodrag nopan"
					style={{
						position: 'absolute',
						transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
						pointerEvents: 'all',
						zIndex: 5,
					}}
				>
					<Button
						size="small"
						variant="contained"
						color="primary"
						startIcon={<PlayArrow />}
						onClick={handlePromoteClick}
						sx={{
							fontSize: '0.68rem',
							minWidth: 96,
							minHeight: 28,
							px: 1.25,
							borderRadius: 14,
							'& .MuiButton-startIcon': { mr: 0.5, '& svg': { fontSize: 17 } },
							boxShadow: `0 2px 4px ${alpha(theme.palette.common.black, 0.2)}`,
						}}
						title="Promote components to next environment"
					>
						Promote
					</Button>
				</div>
			</EdgeLabelRenderer>
		</>
	);
}
